module.exports = __webpack_public_path__ + "img/system.5e65137e.jpg";